export enum ObjectType {
    Door = 'door',
    NPC = 'npc',
    Object = 'object'
}